module.exports = __webpack_public_path__ + "img/times-black.12cc0b2d.svg";